import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';

interface RoleRouteProps {
  roles: Array<'free' | 'premium' | 'admin'>;
  children: React.ReactNode;
  redirectTo?: string;
  fallback?: React.ReactNode;
}

const RoleRoute: React.FC<RoleRouteProps> = ({ 
  roles, 
  children, 
  redirectTo = '/login',
  fallback 
}) => {
  const { t } = useTranslation();
  const { user, token } = useAuth();
  const location = useLocation();

  // Si no hay token, redirigir al login
  if (!token) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  // Si no hay usuario pero hay token, mostrar fallback o loading
  if (!user) {
    return fallback || (
      <div style={{ padding: 20, textAlign: 'center' }}>
        {t('loading')}...
      </div>
    );
  }

  // Si el usuario no tiene el rol requerido
  if (!roles.includes(user.role)) {
    // Si es usuario free intentando acceder a premium, redirigir a upgrade
    if (user.role === 'free' && roles.includes('premium')) {
      return <Navigate to="/upgrade" state={{ from: location }} replace />;
    }
    
    // Para otros casos, redirigir a la página principal
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Usuario autenticado y con rol correcto
  return <>{children}</>;
};

export default RoleRoute; 